export * from './useTodosQuery';
export * from './hooks';

export const getTodosQueryKey = (params: { pageSize?: number; featured?: boolean }) => ['todos', params];
